import { Row } from 'src/components-v2/Layout';
import styled from 'threads5/themes/styled';

const Text = styled('p')(({ theme }) => {
  return {
    fontFamily: theme.typography.sans,
    fontSize: '1.4rem',
    color: theme.palette['base/black/800'],
    marginBottom: 0,
  };
});

const Disclaimer = () => {
  return (
    <Row
      lgOffset={2}
      lg={20}
      sx={{
        padding: { sm: '20px 25px' },
      }}
    >
      <Text>*Talk to a Plaid Contact to learn more</Text>
    </Row>
  );
};

export default Disclaimer;
